import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { format } from 'date-fns';
import Logo from '@icons/white-logo.svg';

const styles = StyleSheet.create({
    page: { padding: 30, fontFamily: 'Helvetica' },
    header: { textAlign: 'center', marginBottom: 20 },
    logo: { width: 80, marginBottom: 10, alignSelf: 'center' },
    title: { fontSize: 26, textAlign: 'center', marginBottom: 5 },
    subTitle: { fontSize: 16, textAlign: 'center', marginBottom: 20 },
    section: { marginBottom: 15 },
    sectionHeader: { fontSize: 14, fontWeight: 'bold', marginBottom: 8 },
    text: { fontSize: 12, marginBottom: 4 },
    label: { fontWeight: 'bold' },
    invoiceBox: {
        padding: 10,
        border: '1 solid #cccccc',
        borderRadius: 4,
        marginBottom: 20
    },
    status: { fontSize: 12, fontWeight: 'bold' },
    red: { color: 'red' },
    green: { color: 'green' }
});

const BillingInvoiceGroup = ({ data }) => {
    const { invoice, groupAdmin } = data;

    const fullAddress = [
        groupAdmin?.streetAddress,
        groupAdmin?.streetAddress2,
        groupAdmin?.city,
        groupAdmin?.state,
        groupAdmin?.zipCode
    ]
        .filter(Boolean)
        .join(', ');

    const statusStyle = invoice?.status === 'PENDING' || invoice?.status === 'OVERDUE' ? styles.red : styles.green;

    // For this elegant design, let's compute Amount Payable as the sum of invoiceTotal and processingFee.
    const amountPayable = Number(invoice?.invoiceTotal) + Number(invoice?.processingFee);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header */}
                <View style={styles.header}>
                    <Image style={styles.logo} src={Logo} />
                    <Text style={styles.title}>Billing Invoice</Text>
                    <Text style={styles.subTitle}>Group Admin Invoice</Text>
                </View>

                {/* Group Admin Details */}
                <View style={styles.section}>
                    <Text style={styles.sectionHeader}>Group Admin Details</Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Name: </Text>
                        {groupAdmin?.firstName} {groupAdmin?.lastName}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Group Name: </Text>
                        {groupAdmin?.groupName || 'N/A'}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Title: </Text>
                        {groupAdmin?.title || 'N/A'}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Address: </Text>
                        {fullAddress || 'N/A'}
                    </Text>
                </View>

                {/* Invoice Details */}
                <View style={[styles.section, styles.invoiceBox]}>
                    <Text style={styles.sectionHeader}>Invoice Details</Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Invoice Number: </Text>
                        {invoice?.invoiceNumber}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Invoice Date: </Text>
                        {invoice?.createdAt ? format(new Date(invoice?.createdAt), 'yyyy-MM-dd') : 'N/A'}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Due Date: </Text>
                        {invoice?.dueDate ? format(new Date(invoice?.dueDate), 'yyyy-MM-dd') : 'N/A'}
                    </Text>
                    <Text style={[styles.text, styles.status, statusStyle]}>
                        <Text style={styles.label}>Status: </Text>
                        {invoice?.status}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Invoice Total: </Text>${invoice?.invoiceTotal.toFixed(2)}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Processing Fee: </Text>${invoice?.processingFee.toFixed(2)}
                    </Text>
                    <Text style={styles.text}>
                        <Text style={styles.label}>Amount Payable: </Text>${amountPayable.toFixed(2)}
                    </Text>
                </View>
            </Page>
        </Document>
    );
};

export default BillingInvoiceGroup;
